import { render } from "./UploadTotalSize.vue?vue&type=template&id=6fba5e18&ts=true"
import script from "./UploadTotalSize.vue?vue&type=script&lang=ts"
export * from "./UploadTotalSize.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__